import {useAccountStatsQuery} from 'api/generated';
import {formatAmount} from 'lib/formaters';
import React from 'react';

export const GMV: React.FC<{accountId: string}> = ({accountId}) => {
  const {data} = useAccountStatsQuery({variables: {accountId}});
  if (!data?.accountStats.stats) return null;
  return formatAmount(
    data?.accountStats.stats.avgMonthlyVolume,
    'EUR',
    0
  ) as unknown as React.ReactElement;
};
